import { render } from "./IconoReparto.vue?vue&type=template&id=c84555f6"
import script from "./IconoReparto.vue?vue&type=script&lang=js"
export * from "./IconoReparto.vue?vue&type=script&lang=js"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__